import type { ProductDetailType } from "@/types/shop-type";
import type { LocaleTextType } from "@/types/types";
import { createContext, type Dispatch, type SetStateAction } from "react";

export const ShopContext = createContext<{
    product: ProductDetailType[] | null;
    setProduct: Dispatch<SetStateAction<ProductDetailType[] | null>>;
    category: LocaleTextType[] | null;
    setCategory: Dispatch<SetStateAction<LocaleTextType[] | null>>;
}>({
    product: null,
    setProduct: () => null,
    category: null,
    setCategory: () => null,
});
